// extracted by mini-css-extract-plugin
export default {"root":"style_root__24hli","panel":"style_panel__2gjmi","panelMatchInputWidth":"style_panelMatchInputWidth__2YCNl"};